<template>
  <div>
    <v-layout class="mt-2">
      <v-flex xs6>
        <BuscaSimplesApi
          style="width: 100%"
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/areaatuacao"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi"
        >
          <template slot-scope="propSlot">
            <span
              >{{ propSlot.item.identificadorareaatuacaofuncionario }} -
              {{ propSlot.item.descricaoareaatuacaofuncionario }}</span
            >
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select
          :options="buscaOptions"
          v-model="buscarSelect"
          label=""
          @change="selectBuscaChange"
        />
      </v-flex>
    </v-layout>

    <v-alert
      type="error"
      :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0"
      style="color: white"
    >
      <div v-if="$v.$invalid && $v.$dirty">
        Preencha os campos corretamente.
      </div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :submit="onSubmit"
      :acao="acao"
      :novo="novaAreaAtuacao"
      :editar="editarAreaAtuacao"
      :excluir="deletarAreaAtuacao"
      :cancelar="cancelarAreaAtuacao"
      :id="form.identificadorareaatuacaofuncionario"
      class="mb-3"
    >
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaAreaAtuacao">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>

      <v-card class="pa-3">
        <Input
          ref="id"
          type="text"
          label="Código da Área de Atuação"
          disabled
          v-model="form.identificadorareaatuacaofuncionario"
        />
        <Input
          ref="descricao"
          :disabled="acao == ''"
          v-model="form.descricaoareaatuacaofuncionario"
          label="Descrição da Área de Atuação"
          :v="$v.form.descricaoareaatuacaofuncionario"
        />
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import BuscaSimplesApi from "@/components/BuscaSimplesApi";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { words } from "@/validations";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const AreaAtuacaoRepository = RepositoryFactory.get("areaAtuacao");

const setFormInicial = () => ({
  identificadorareaatuacaofuncionario: "",
  descricaoareaatuacaofuncionario: "",
});

export default {
  name: "areaatuacao",
  components: { BuscaSimplesApi },

  data() {
    return {
      acao: "",
      form: setFormInicial(),
      msgError: "",
      msgArrayError: [],
      snackbar: false,
      submitText: "",
      formUltimo: {},
      buscarSelect: "identificadorareaatuacaofuncionario",
      buscaOptions: [
        { value: "identificadorareaatuacaofuncionario", text: "Código" },
        { value: "descricaoareaatuacaofuncionario", text: "Descrição" },
      ],
    };
  },

  validations() {
    return {
      form: {
        descricaoareaatuacaofuncionario: {
          required,
          words,
          minLength: minLength(4),
          maxLength: maxLength(50),
        },
      },
      /*   GAMBIARRA
           A regra de validação abaixo foi inserida apenas para corrigir um pequeno erro na interface de usuário que ocorre quando o botão cancelar é usado.

           Quando a última regra de validação declarada não é válida, a validação impede que o botão cancelar seja executado.
           Porém, quando a última regra é válida, o erro não ocorre.
           Nesse caso, como nesta tela só há um campo sendo validado e ele não está válido quando o botão cancelar é clicado,
           é necessário lançar uma regra vazia abaixo somente para evitar de o erro ocorrer.
      */
      submitText: {},
    };
  },

  methods: {
    tabelaAreaAtuacao() {
      this.$root.$router.push({
        name: "tabelas",
        params: {
          titulo: "Área de Atuação / Listar",
          rota_api: "gerencial/areaatuacao/tabela",
          headers: [
            {
              text: "Código",
              value: "identificadorareaatuacaofuncionario",
              filtable: true,
              sortable: false,
            },
            {
              text: "Descrição da Área de Atuação",
              value: "descricaoareaatuacaofuncionario",
              filtable: true,
              sortable: false,
            },
          ],
        },
      });
    },

    novaAreaAtuacao() {
      this.acao = "novo";
      this.form = setFormInicial();
      this.$v.$reset();
      setTimeout(() => this.$refs.descricao.$refs.input.focus(), 200);
    },

    editarAreaAtuacao() {},

    async deletarAreaAtuacao() {
      const confirmar = await this.$sgal({
        title: "Tem certeza?",
        text: "Deseja realmente excluir está área de atuação?",
        type: "warning",
        buttons: [
          { text: "Excluir", color: "red", response: true },
          { text: "Cancelar", color: "grey", response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await AreaAtuacaoRepository.deletarAreaAtuacao(
            this.form.identificadorareaatuacaofuncionario
          );

          this.acao = "";
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: "Não foi possível!",
            text: error.response.data.errorMessage,
            type: "notification",
          });
        }
      }
    },

    cancelarAreaAtuacao() {
      if (this.acao === "novo") {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = "";
      this.msgArrayError = [];
      this.$v.$reset();
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        if (window.scrollY >= 250) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
        return;
      }

      try {
        const { data } = await AreaAtuacaoRepository.postAreaAtuacao(this.form);

        this.acao = "";
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];

        this.form = { ...data.results };
        this.formUltimo = { ...this.form };
      } catch (error) {
        if (error.response.data.status == "ERROR_BUSINESS_RULE") {
          this.msgArrayError = error.response.data.errorMessage;
        }
        if (window.scrollY >= 250) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
      this.$v.$reset();
      return true;
    },

    encontrado(dados) {
      this.form = setFormInicial();
      this.form = { ...dados };
      this.formUltimo = { ...this.form };
      this.$refs.buscaSimpleApi.lista = [];
    },

    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = "";
    },
  },
};
</script>

<style lang="scss" scoped>
/* /deep/ #btn-acoes-t button:nth-child(2) {
  display: none !important;
} */
::v-deep #btn-acoes-t button:nth-child(2) {
  display: none !important;
}
</style>
